import { getEventPath } from './getEventPath';
import { isNotEmptyArray } from './isNotEmptyArray';
export const getTargetElementProps = (e) => {
    var _a, _b, _c, _d, _e;
    const path = isNotEmptyArray(e === null || e === void 0 ? void 0 : e.composedPath())
        ? e.composedPath()
        : isNotEmptyArray(e === null || e === void 0 ? void 0 : e.path)
            ? e.path
            : [];
    return {
        text: (_a = e.target.innerText) === null || _a === void 0 ? void 0 : _a.slice(0, 100),
        tag: (_b = e.target) === null || _b === void 0 ? void 0 : _b.localName,
        class: ((_c = e.target) === null || _c === void 0 ? void 0 : _c.className) && typeof ((_d = e.target) === null || _d === void 0 ? void 0 : _d.className) === 'string'
            ? e.target.className
            : '',
        id: (_e = e.target) === null || _e === void 0 ? void 0 : _e.id,
        path: getEventPath(path),
    };
};
//# sourceMappingURL=getTargetElementProps.js.map